import {Component, ElementRef, OnInit, SecurityContext, ViewEncapsulation} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExcRestService} from 'exc-rest-v2';
import {EnumerationService} from '../services/enumeration.service';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  encapsulation: ViewEncapsulation.None
})

export class DashboardComponent extends ExcTranslation implements OnInit {
  homeSummaryData = {
    case: {} as any,
    task: {} as any,
    message: {} as any,
    aufgabe: {} as any,
    isLoading: true,

    loadData: (incomingCase: any, incomingTask?: any) => {
      this.homeSummaryData.case = incomingCase;
      this.homeSummaryData.task = incomingTask;
    }
  };

  constructor(private excRestService: ExcRestService,
              public enumerationService: EnumerationService,
              public sanitizer: DomSanitizer,
              private elRef: ElementRef) {
    super();
  }

  ngOnInit(): void {
    this.initialize();
    ExcCoreModule.Services().GlobalRefresh.subscribe(() => {
      this.loadHomeSummary();
    });
  }

  initialize(): void {
    const SELF = this;
    SELF.loadHomeSummary();
  }

  loadHomeSummary(): void {
    const SELF = this;
    SELF.homeSummaryData.isLoading = true;
    SELF.excRestService
      .get(SELF.excRestService.computeUrl('HomeR_Summary'))
      .subscribe(
        (data: any) => {
          if (data && data.success) {
            SELF.homeSummaryData.loadData(
              data.data.Auftrag,
              data.data.Vorgang);
          }
          SELF.homeSummaryData.isLoading = false;
        }
      );
  }

  calculatePercentage(num: number, total: number): string {
    return total && total >= 0 ? (num * 100 / total).toFixed(2) : '0';
  }

  getTestRessource(test: string) {
    return this.sanitizer.sanitize(SecurityContext.HTML, this.getRessource(test));

  }
}
